<template>
  <div class="quota-page">
    <div class="content-card">
      <div class="tab-bar">
        <button :class="{ active: activeTab === 'overview' }" @click="activeTab = 'overview'">
          {{ $t('HT.subordinate.quota.overview') }}</button
        ><button :class="{ active: activeTab === 'records' }" @click="activeTab = 'records'">
          {{ $t('HT.subordinate.quota.records') }}
        </button>
      </div>
      <div v-show="activeTab === 'overview'">
        <quota-overview
          ref="quotaOverview"
          @adjust="openAdjust"
          @withdraw="openWithdraw"
        ></quota-overview>
      </div>
      <div v-show="activeTab === 'records'">
        <quota-records ref="quotaRecords"></quota-records>
      </div>
    </div>
  </div>
</template>

<script lang="jsx">
import QuotaOverview from './components/quotaOverview.vue';
import QuotaRecords from './components/quotaRecords.vue';
import QuotaAllocationModal from './components/quotaAllocationModal.vue';
import QuotaWithdrawModal from './components/quotaWithdrawModal.vue';

// 接口配额单位为次，页面表单单位为万次
const QUOTA_UNIT = 10000;

export default {
  name: 'SubordinateQuota',
  components: { QuotaOverview, QuotaRecords, QuotaAllocationModal, QuotaWithdrawModal },
  data() {
    return {
      activeTab: 'overview'
    };
  },
  methods: {
    // 获取指定账号产品可用余额后打开调整配额弹窗
    openAdjust(row) {
      // 当前登录账号 ID，用于查询其指定产品的可用余额
      const accountId = Number(this.$store.state.login.userData.id);
      const productId = Number(row.product_id);
      if (!Number.isInteger(accountId) || accountId <= 0 || !Number.isInteger(productId) || productId <= 0) {
        this.$uxMessage.error(this.$t('HT.subordinate.quota.accountProductIncomplete'));
        return;
      }
      this.$uxLoading.show();
      this.$api.accountQuota.getRemainingQuota(accountId, productId).then((res) => {
        if (res.code == 10000) {
          // 接口余额由次转换为万次，作为弹窗可分配上限
          const availableBalance = Number(res.data || 0) / QUOTA_UNIT;
          this.$uxModal.show({
            title: this.$t('HT.subordinate.quota.adjustTitle'),
            width: '520px',
            content: (h) =>
              h(QuotaAllocationModal, {
                props: {
                  account: row,
                  mode: 'adjust',
                  availableBalance
                }
              }),
            confirm: (data) => this.submitAdjustment(row, data)
          });
        }
      });
    },
    // 提交账号产品调整后的新配额
    submitAdjustment(row, formData) {
      const accountId = Number(row.account_id);
      const productId = Number(row.product_id);
      // 页面输入为万次，提交接口前转换为次
      const newQuota = Number(formData.amount) * QUOTA_UNIT;
      if (!Number.isInteger(accountId) || accountId <= 0 || !Number.isInteger(productId) || productId <= 0) {
        this.$uxMessage.error(this.$t('HT.subordinate.quota.accountProductIncomplete'));
        return;
      }
      if (!Number.isFinite(newQuota) || newQuota < 0) {
        this.$uxMessage.error(this.$t('HT.subordinate.quota.adjustedQuotaNonnegative'));
        return;
      }
      if (newQuota < Number(row.used_quota || 0)) {
        this.$uxMessage.error(this.$t('HT.subordinate.quota.adjustedQuotaBelowUsed'));
        return;
      }
      this.$uxLoading.show();
      this.$api.accountQuota
        .adjust({
          account_id: accountId,
          new_quota: newQuota,
          product_id: productId,
          remark: formData.remark || ''
        })
        .then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.subordinate.quota.adjustSuccess'));
            if (this.$refs.quotaOverview) {
              this.$refs.quotaOverview.getList();
            }
            if (this.$refs.quotaRecords) {
              this.$refs.quotaRecords.getRecords();
            }
          }
        });
    },
    // 获取撤回详情并打开配额撤回弹窗
    openWithdraw(row) {
      const accountId = Number(row.account_id);
      const productId = Number(row.product_id);
      if (!Number.isInteger(accountId) || accountId <= 0 || !Number.isInteger(productId) || productId <= 0) {
        this.$uxMessage.error(this.$t('HT.subordinate.quota.accountProductIncomplete'));
        return;
      }
      this.$uxLoading.show();
      this.$api.accountQuota.getRevokeInfo(accountId, productId).then((res) => {
        if (res.code == 10000) {
          const revokeInfo = res.data || {};
          this.$uxModal.show({
            title: this.$t('HT.subordinate.quota.revokeTitle'),
            width: '560px',
            content: (h) =>
              h(QuotaWithdrawModal, {
                props: {
                  account: row,
                  revokeInfo
                }
              }),
            confirm: (data) => this.submitWithdraw(row, revokeInfo, data)
          });
        }
      });
    },
    // 提交配额撤回并刷新操作记录
    submitWithdraw(row, revokeInfo, formData) {
      // 页面输入为万次，提交接口前转换为次
      const amount = Number(formData.amount) * QUOTA_UNIT;
      if (!Number.isFinite(amount) || amount <= 0 || amount > Number(revokeInfo.remaining_quota || 0)) {
        this.$uxMessage.error(this.$t('HT.subordinate.quota.revokeAmountExceeded'));
        return;
      }
      this.$uxLoading.show();
      this.$api.accountQuota
        .revoke({
          account_id: Number(row.account_id),
          product_id: Number(row.product_id),
          reason: formData.reason,
          remark: formData.remark || '',
          revoke_amount: amount
        })
        .then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.subordinate.quota.revokeSuccess'));
            if (this.$refs.quotaOverview) {
              this.$refs.quotaOverview.getList();
            }
            if (this.$refs.quotaRecords) {
              this.$refs.quotaRecords.getRecords();
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.quota-page {
  min-width: 1080px;
  padding: 24px;
  color: #1f2937;
}
.content-card {
  background: #fff;
  border: 1px solid #edf0f5;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(35, 50, 80, 0.04);
}
.tab-bar {
  display: flex;
  height: 54px;
  padding: 0 22px;
  border-bottom: 1px solid #edf0f5;
  button {
    position: relative;
    padding: 0 22px;
    border: 0;
    background: transparent;
    color: #7d8799;
    font-size: 14px;
    cursor: pointer;
    &.active {
      color: #409eff;
      font-weight: 500;
      &:after {
        position: absolute;
        right: 22px;
        bottom: -1px;
        left: 22px;
        height: 2px;
        background: #409eff;
        content: '';
      }
    }
  }
}

.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
  .name-filter {
    width: 250px;
  }
  .record-name-filter {
    width: 220px;
  }
  .record-select {
    width: 140px;
  }
  .record-date {
    width: 270px;
  }
  .export-button {
    margin-left: auto;
  }
}
.account-name,
.record-account {
  padding: 0;
  font-size: 13px;
}
.gift-tip {
  display: block;
  color: #a4adbb;
  font-size: 11px;
  line-height: 18px;
}
.usage-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  .el-progress {
    flex: 1;
  }
  span {
    width: 46px;
    color: #5d6879;
    font-size: 12px;
    text-align: right;
  }
}
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 18px;
  color: #8a94a6;
  font-size: 12px;
}
.increase {
  color: #21b779;
}
.decrease {
  color: #f56c6c;
}
.dialog-input {
  width: 320px;
}
.form-hint {
  margin: 4px 0 0;
  color: #929baa;
  font-size: 12px;
  line-height: 18px;
}
.form-error {
  margin: 4px 0 0;
  color: #f56c6c;
  font-size: 12px;
  line-height: 18px;
}
.warning-box {
  display: flex;
  padding: 12px 14px;
  margin-bottom: 18px;
  border: 1px solid #ffe3b2;
  border-radius: 4px;
  background: #fff9ed;
  color: #fa8c16;
  font-size: 13px;
  i {
    margin: 2px 8px 0 0;
    font-size: 16px;
  }
  strong {
    font-weight: 500;
  }
  p {
    margin: 6px 0 0;
    color: #a97836;
    font-size: 12px;
    line-height: 18px;
  }
}
.account-panel {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 18px;
  padding: 14px 18px;
  margin-bottom: 18px;
  border-radius: 4px;
  background: #f7f9fc;
  font-size: 13px;
  div {
    display: flex;
    justify-content: space-between;
  }
  span {
    color: #929baa;
  }
  strong {
    font-weight: 500;
  }
}
.orange-text {
  color: #fa8c16;
}
@media screen and (max-width: 1280px) {
  .quota-page {
    padding: 18px;
  }
}
</style>
